import styled, { keyframes } from 'styled-components';
import { AiOutlineLoading3Quarters } from 'react-icons/ai'
import { FaInfoCircle } from 'react-icons/fa'

export const RunModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    z-index: 99;
    overflow: auto;
`;

export const ModalContainer = styled.div`
    background: white;
    padding: 20px;
    border-radius: 8px;
    max-width: 600px;
    width: 100%;
    height: auto;
    max-height: 600px;
    justify-content: center;
    align-items: center;
    display: flex;
    margin-top: 150px;
    flex-direction: column;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    
    @media screen and (max-width: 490px){
        width: 90%;
        max-height: 60%;
      }
`;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  z-index: 98;
  margin: 12px;
`;

export const InfoLabel = styled.span`
  background: none;
  border: none;
  margin-right: 8px;
  font-size: 16px;
  color: #cc8f2d;
  font-weight: bold;
  cursor: pointer;
  text-decoration: underline;
  text-underline-offset: 4px; 
  
  &:hover {
    color: #000; 
  }

  &:focus-visible {
    outline: 2px solid #000;
    outline-offset: 2px;
    border-radius: 2px;
  }
`;


export const StyledIconInfo = styled(FaInfoCircle)`
 color: #cc8f2d;

  &:hover {
    color: #000;
    transition: 0.2s ease-in-out;
  }
`;

export const InputWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  max-width: 100px;
`;

export const CurrencySymbol = styled.span`
  position: absolute;
  left: 12px;
  font-size: 15px;
  color: #666666;
  pointer-events: none; 
`;

export const StyledInput = styled.input`
  width: 100%;
  padding: 10px 10px 10px 28px;
  border-color: #101522;
  border-radius: 4px;
  font-size: 15px;
  box-sizing: border-box;
  max-height: 32px;

  &:focus {
    outline: none;
    border: 2px solid #cc8f2d;
  }
`;

export const FormSelectDropdownContainer = styled.div`
  align-items: center;
  z-index: 98;
  margin: 12px;
`;

export const FormLabel = styled.label`
  margin-bottom: 8px;
  margin-right: 8px;
  font-size: 16px;
  color: #cc8f2d;
  font-weight: bold;
`;


export const FormSelect = styled.select`
  color: black;
  background: #cc8f2d;
  font-weight: bold;
  border: none;
  padding: 8px;
  border-radius: 8px;
`;


export const FormButton = styled.button`
  background: #cc8f2d;
  border: none;
  border-radius: 4px;
  color: black;
  font-size: 20px;
  margin: 20px;
  cursor: pointer;
  height: 30px;
  width: 200px;
`;



export const ModalCloseButton = styled.button`
  border-radius: 50px;
  background: none;
  white-space: nowrap;
  padding: 2px 8px;
  color: #cc8f2d;
  font-size: 20px;
  outline: none;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-decoration: none;
  text-align: center;
  margin:2px;

  &:hover {
    transition: all 0.2s ease-in-out;
    background: #fff;
    color: #cc8f2d;
  }
`;


export const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`

export const SpinningIcon = styled(AiOutlineLoading3Quarters)`
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-left-color: #cc8f2d;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  animation: ${spin} 1s linear infinite;
`

export const DescriptionContainer = styled.div`
  position: absolute;
  top: ${({ top }) => top};
  right: ${({ right }) => right};
  margin-top: 18px;
  justify-content: center;
  background: black;
  border-radius: 4px;
  max-width: 400px;
  padding: 10px;
  z-index: 1008;

 @media screen and (max-width: 490px){
    right: ${({ tuneRight }) => tuneRight ? '100px' : '3px'};
    top: ${({ tuneTop, tuneTopVal, top }) => tuneTop ? tuneTopVal : top};
    max-width:${({ tuneRight }) => tuneRight ? '200px' : '70px'};
    font-size: 12px;
    margin-top: -28px;
  }
`;


export const DescriptionTopLine = styled.div`
  justify-content: center;
  text-align: left;
  // letter-spacing: 1.4px;
  text-transform: uppercase;
  color: #cc8f2d;
  margin-bottom: 10px;

 @media screen and (max-width: 490px){
    right: 9px;
    font-size: 10px;
    margin-bottom: 5px;
  }
`;

export const DescriptionP = styled.div`
  justify-content: center;
  color: #ffffff;
  border-bottom: 2px solid white;
  text-align: left;

 @media screen and (max-width: 490px){
    right: 10px;
    font-size: 10px;
  }
`;

export const ToolTipPointer = styled.div`
  position: absolute;
  top: ${({ top }) => top};
  right: ${({ right }) => right};
  height: 0;
  width: 0;
  border-left: 12px solid black;
  border-top: 14px solid transparent;
  border-bottom: 14px solid transparent;
  z-index: 98;

 @media screen and (max-width: 490px){
    max-width: 80px;
    right: ${({ tuneRight, tuneRightVal }) => tuneRight ? '102px' : '65px'};
    top: ${({ tuneTop, tuneTopVal, top }) => tuneTop ? tuneTopVal : top};
    font-size: 10px;
    border-left: none;
    border-right: 12px solid black;
    z-index: 97;
  }
`;